module.exports = __webpack_public_path__ + "static/media/ribeirao-original.07b93b22.png";